import { activeSubHasPurchasedProductLine } from '@/data/flags/product-lines.js';

export const getFilterChoiceConfig = () => {
    const hasOrchestrate = activeSubHasPurchasedProductLine('orchestrate');
    const hasEmbeddedGuidesEnabled = activeSubHasPurchasedProductLine('guides', 'embeddedGuidesEnabled');
    const isAdoptEndUser = activeSubHasPurchasedProductLine('adoptEndUser');
    const hasSurveys = activeSubHasPurchasedProductLine('surveys');

    return {
        statuses: [
            {
                id: 'public',
                name: 'Public',
                icon: {
                    type: 'circle',
                    size: '8',
                    fill: 'var(--palette-green-70)',
                    stroke: 'var(--palette-green-70)',
                    class: 'status-circle',
                },
            },
            !isAdoptEndUser && {
                id: 'staged',
                name: 'Staged',
                icon: {
                    type: 'circle',
                    size: '8',
                    fill: 'var(--palette-yellow-100)',
                    stroke: 'var(--palette-yellow-100)',
                    class: 'status-circle',
                },
            },
            {
                id: 'scheduled',
                name: 'Scheduled',
                icon: {
                    type: 'circle',
                    size: '8',
                    fill: 'var(--palette-orange-70)',
                    stroke: 'var(--palette-orange-70)',
                    class: 'status-circle',
                },
            },
            {
                id: 'draft',
                name: 'Draft',
                icon: {
                    type: 'circle',
                    size: '8',
                    fill: 'var(--palette-blue-90)',
                    stroke: 'var(--palette-blue-90)',
                    class: 'status-circle',
                },
            },
            {
                id: '_pendingReview_',
                name: 'Pending review',
                icon: {
                    type: 'circle',
                    size: '8',
                    fill: 'var(--palette-blue-40)',
                    stroke: 'var(--palette-blue-40)',
                    class: 'status-circle',
                },
            },
            {
                id: 'disabled',
                name: 'Disabled',
                icon: {
                    type: 'circle',
                    size: '8',
                    fill: 'var(--palette-gray-70)',
                    stroke: 'var(--palette-gray-70)',
                    class: 'status-circle',
                },
            },
        ].filter(Boolean),
        activations: [
            'App launch',
            'Automatic',
            'Badge',
            'Confirmation',
            'Element click',
            hasEmbeddedGuidesEnabled && 'Embedded',
            'Guide center',
            'Page view',
            'Programmatic',
            'Resource center',
        ].filter(Boolean),
        deviceTypes: ['Desktop', 'Mobile web', 'Desktop and mobile web', 'iOS', 'Android'],
        expirations: ['Active', 'Expired'],
        guideTypes: [
            'Banner',
            'Building block',
            'Guide group',
            'Lightbox',
            'Tooltip',
            'Training',
            'Walkthrough',
            { id: 'Whatsnew', label: "What's new" },
        ],
        managedIn: [
            hasOrchestrate && {
                prop: 'journeyId',
                id: 'orchestrate',
                label: 'Orchestrate',
            },
            hasSurveys && {
                prop: 'surveyId',
                id: 'sentiment',
                label: 'Sentiment',
            },
        ].filter(Boolean),
    };
};

const FilterChoiceConfig = getFilterChoiceConfig();

export default FilterChoiceConfig;
